var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 -2.6575 159.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.23 1558.3c1.5938-1.5001 2.3438-3.2813 2.3438-5.3438 0-2.8125-3.4688-6.5625-39.656-42.656-36.844-36.938-39.844-39.656-42.844-39.656-2.9063 0-4.7813 1.5001-20.344 17.156-15.281 15.187-17.156 17.438-17.156 20.156 0 4.1249 3.5625 7.6874 7.5938 7.6874 2.625 0 4.7812-1.6875 16.5-13.312l13.406-13.312 35.906 35.812c32.531 32.531 36.187 35.812 38.906 35.812 2.0625 0 3.8438-0.8438 5.3438-2.3437z",
    fill: "#fff",
    strokeWidth: 0.70312
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.824f15dedcf40b4dff0aa96c2bb2ae6e.svg";
export { ForwardRef as ReactComponent };